var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 477,
    height: 264,
    viewBox: "0 0 477 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.793 93.1497C186.283 90.645 179.281 71.6092 129.768 58.5847C84.0983 46.5711 68.2139 78.0298 62.8834 84.1648C55.3372 82.4843 38.2443 93.4503 30.2422 150.758C20.2396 222.393 73.2535 234.916 95.7594 224.397C118.265 213.877 118.765 227.402 159.276 224.397C199.787 221.391 233.796 233.414 294.312 234.916C342.724 236.119 392.171 224.063 410.842 217.884C425.179 167.623 452.553 67.1007 447.352 67.1007C440.85 67.1007 409.842 106.675 389.336 114.189C368.831 121.703 367.831 100.163 366.831 93.1497C365.83 86.1365 357.828 48.0649 304.814 33.0366C251.8 18.0084 299.813 47.063 281.808 85.1346C263.804 123.206 259.302 95.6544 222.793 93.1497Z",
    fill: "url(#paint0_linear_1_988)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_988",
    x: 0,
    y: 0,
    width: 477,
    height: 264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_1_988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_988",
    x1: 238.5,
    y1: 29,
    x2: 238.5,
    y2: 235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F69FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.fd8bfa7b503733d45bf0aca71666049d.svg";
export { ForwardRef as ReactComponent };